<template>
  <div>
    <div class="level">
      <div class="level-left" />

      <div class="level-right">
        <div class="level-item">
          <b-button
            v-if="isEditing"
            ref="saveEntryButton"
            size="is-small"
            class="mr-4"
            icon-left="content-save"
            type="is-success"
            @click="updateGoalType"
          >
            save
          </b-button>

          <b-button
            v-if="isEditing"
            ref="cancelEntryButton"
            size="is-small"
            class="mr-4"
            icon-left="close"
            type="is-success"
            @click="cancelUpdate"
          >
            cancel
          </b-button>

          <b-button
            v-if="Object.keys(filters).length > 0"
            size="is-small"
            icon="power-off"
            @click="resetFilters"
          >
            Reset Filters
          </b-button>
        </div>
      </div>
    </div>

    <!-- v-click-outside-dg="onClickOutsideTable" -->
    <b-table
      ref="goalTypesTable"
      :mobile-cards="false"
      :loading="loading"
      :data="goalTypes.content"
      :checkable="customizations.isCheckable"
      :checked-rows.sync="checkedRows"
      paginated
      backend-pagination
      :total="total"
      :per-page="perPage"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
      :narrowed="customizations.isNarrowed"
      :bordered="customizations.isBordered"
      :striped="customizations.isStriped"
      :sticky-header="customizations.isStickyHeaders"
      :scrollable="customizations.isScrollable"
      backend-filtering
      :debounce-search="800"
      backend-sorting
      :default-sort-direction="defaultSortOrder"
      :default-sort="[sortField, sortOrder]"
      :sort-icon="sortIcon"
      :sort-icon-size="sortIconSize"
      @sort="onSort"
      @filters-change="onFilter"
      @page-change="onPageChange"
      @update:selected="onClickOutsideEditing"
    >
      <b-table-column
        v-for="(column, index) in columns"
        :key="index"
        :label="column.label"
        :field="column.field"
        :searchable="column.searchable"
        :sortable="column.sortable"
        :visible="column.visible"
      >
        <template
          slot="searchable"
          slot-scope="props"
        >
          <template>
            <b-switch
              v-if="column.searchField === 'isDefault'"
              v-model="props.filters[`${column.searchField}`]"
              size="is-small"
            />

            <b-input
              v-else-if="
                column.searchField === 'type'
              "
              v-model="props.filters[`${column.searchField}`]"
              placeholder="Search..."
              icon="search"
              size="is-small"
            />
          </template>
        </template>

        <template v-slot="props">
          <template v-if="column.field === 'actions'">
            <template v-if="props.row.isDefault === false">
              <!-- <div class="buttons"> -->
              <b-tooltip
                type="is-info"
                label="Edit"
                position="is-right"
              >
                <b-button
                  type="is-text"
                  class="has-text-grey"
                  icon-right="pencil"
                  @click="onEdit(props.row)"
                />
              </b-tooltip>

              <b-tooltip
                type="is-primary"
                label="Delete"
                position="is-bottom"
              >
                <b-button
                  type="is-text"
                  class="has-text-grey"
                  icon-right="trash-can"
                  @click="deleteGoalType(props.row.id)"
                />
              </b-tooltip>
            <!-- </div> -->
            </template>
            <template v-else>
              <div class="buttons" />
            </template>
          </template>

          <template
            v-if="column.field === 'type'"
          >
            <template
              v-if="isEditing && props.row.id === selectedGoalTypeId
                && props.row.isDefault === false"
            >
              <b-input
                v-model="type"
                size="is-small"
                expanded
              />
            </template>
            <template v-else-if="props.row.isDefault === false">
              <b-tooltip
                label="Double-click to edit"
                class="is-info"
              >
                <span
                  v-if="props.row[column.field]"
                  class="is-pointer"
                  @dblclick="onEdit(props.row)"
                >
                  {{ props.row[column.field] }}
                </span>
              </b-tooltip>
            </template>
            <template v-else>
              <span
                v-if="props.row[column.field]"
                class="is-pointer"
              >
                {{ props.row[column.field] }}
              </span>
            </template>
          </template>

          <template v-else>
            <span>
              {{ props.row[column.field] }}
            </span>
          </template>
        </template>
      </b-table-column>

      <template slot="footer">
        <table-footer
          :first-item="firstItem"
          :page="page"
          :per-page="perPage"
          :total="total"
        >
          <template #page-dropdown>
            <b-dropdown
              v-model="perPage"
              aria-role="list"
              position="is-top-left"
            >
              <b-button
                slot="trigger"
                type="is-info"
                size="is-small"
                icon-right="chevron-down"
              >
                {{ perPage }}
              </b-button>

              <template v-for="(pageCount, index) in pages">
                <b-dropdown-item
                  :key="index"
                  :value="pageCount"
                >
                  {{ pageCount }}
                </b-dropdown-item>
                <hr
                  :key="pageCount"
                  class="dropdown-divider"
                >
              </template>
            </b-dropdown>
          </template>
        </table-footer>
      </template>

      <template slot="empty">
        <empty-table table-name="goal types" />
      </template>
    </b-table>

    <!-- <b-modal
      ref="inlineEditingSavePrompt"
      v-model="isSavePromptActive"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-label="inline editing save modal"
      aria-modal
    >
      <template #default="props">
        <inline-editing-save-prompt
          @save="updateGoalType"
          @close="props.close"
        />
      </template>
    </b-modal> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import {
  TableFooter, EmptyTable,
  // InlineEditingSavePrompt,
} from '@/components/Shared';
import SearchMixin from '@/mixins/SearchMixin';

export default {
  name: 'GoalTypesTable',

  components: {
    TableFooter,
    EmptyTable,
    // InlineEditingSavePrompt,
  },

  mixins: [SearchMixin],

  data: () => ({
    checkedRows: [],

    total: 0,
    page: 1,
    perPage: 25,
    pages: [10, 25, 50, 100, 250, 500, 1000, 2000],

    sortField: 'updatedAt',
    sortOrder: 'desc',
    defaultSortOrder: 'desc',
    sortIcon: 'menu-up',
    sortIconSize: 'is-small',

    isEditing: false,
    selectedGoalTypeId: '',

    isSavePromptActive: false,

    savePromptOpen: false,

    filters: {},

    exportFields: {},

    searchClause: '',

    columns: [
      {
        id: '1',
        label: 'Goal Type',
        field: 'type',
        sortable: true,
        searchable: true,
        searchField: 'type',
        exportField: 'type',
        sticky: false,
        visible: true,
      },
      {
        id: '2',
        label: 'Is Default',
        field: 'isDefault',
        sortable: true,
        searchable: false,
        searchField: 'isDefault',
        exportField: 'isDefault',
        sticky: false,
        visible: true,
      },
      {
        id: '3',
        label: 'Actions',
        field: 'actions',
        sortable: true,
        searchable: false,
        searchField: '',
        exportField: '',
        sticky: false,
        visible: true,
      },
    ],

    customizations: {
      isBordered: false,
      isCheckable: false,
      isNarrowed: false,
      isStickyHeaders: false,
      isScrollable: true,
      isStriped: true,
    },

  }),

  computed: {
    ...mapGetters({
      grid: 'Grids/getGoalTypesGrid',
      loading: 'DataGrids/getLoading',
      goalTypes: 'DataGrids/getGoalTypes',
      goalType: 'Settings/getGoalType',
    }),

    firstItem() {
      const firstItem = this.page * this.perPage - this.perPage + 1;
      return firstItem >= 0 ? firstItem : 0;
    },

    type: {
      get() {
        return this.$store.state.Settings.goalTypes.goalType.type;
      },

      set(value) {
        return this.$store.commit('Settings/SET_GOAL_TYPE_NAME', value);
      },
    },

    isDefault: {
      get() {
        return this.$store.state.Settings.goalTypes.goalType.isDefault;
      },

      set(value) {
        return this.$store.commit('Settings/SET_GOAL_TYPE_DEFAULT', value);
      },
    },
  },

  watch: {
    perPage: {
      handler() {
        this.fetchGoalTypes();
      },
      deep: true,
    },

    columns: {
      handler(value) {
        this.generateExportFields(value);
      },

      deep: true,
      immediate: true,
    },
  },

  async created() {
    try {
      const organizationId = localStorage.getItem('organization_id');
      const response = await this.$store.dispatch('Grids/fetchGoalTypesGrid', {
        gridName: 'goalTypes',
        organizationId,
      });
      await this.$store.dispatch('Settings/fetchLookups');

      if (response) {
        const isConfigurationValid = this.configurationValidator();
        if (isConfigurationValid) {
          this.setGrid();
        }
      } else {
        await this.$store.dispatch('Grids/createGrid', {
          organizationid: localStorage.getItem('organization_id'),
          userid: localStorage.getItem('user_id'),
          columns: this.columns,
          name: 'goalTypes',
          customizations: this.customizations,
        });
      }
    } catch (error) {
      console.error(error);
    }
  },

  mounted() {
    this.filters = { ...this.$route.query };
    this.fetchGoalTypes();
  },

  destroyed() {
    if (localStorage.getItem('access_token')) {
      this.$store.dispatch('Grids/updateGrid', {
        organizationid: localStorage.getItem('organization_id'),
        userid: localStorage.getItem('user_id'),
        columns: this.columns,
        name: 'goalTypes',
        customizations: this.customizations,
      });
    }
    this.$store.commit('Settings/CLEAR_GOAL_TYPES');
  },

  methods: {
    generateExportFields(data) {
      const result = data
        .filter((el) => el.visible && el.exportField)
        .map((el) => [el.label, el.exportField]);
      this.exportFields = Object.fromEntries(new Map(result));
    },

    configurationValidator() {
      const defaultConfiguration = this.columns.map((el) => el.label).sort();
      const userConfiguration = this.grid.columns.map((el) => el.label).sort();
      const result = defaultConfiguration.every(
        (configuration, index) => configuration === userConfiguration[index],
      );
      return result;
    },

    onClickOutsideEditing(row) {
      if (row.id && this.isEditing) {
        if (row.id !== this.selectedGoalTypeId) {
          this.savePromptOpen = true;
          this.isSavePromptActive = true;
        }
      }
    },

    onClickOutsideTable() {
      if (this.isEditing) {
        this.savePromptOpen = true;
        this.isSavePromptActive = true;
      }
    },

    setGrid() {
      this.columns.sort(
        (a, b) => this.grid.columns.findIndex((el) => el.label === a.label)
          - this.grid.columns.findIndex((el) => el.label === b.label),
      );
      const newColumns = this.columns.map((el, index) => ({
        ...el,
        visible: this.grid.columns[index].visible,
      }));
      this.columns = newColumns;
      this.customizations = this.grid.customizations;
    },

    /**
     * fetchGoalTypes
     *
     */
    async fetchGoalTypes() {
      let filters;
      if (typeof this.filters !== 'object') {
        filters = '';
      } else {
        filters = { ...this.filters };
        Object.keys(filters).forEach((key) => filters[key] === '' && delete filters[key]);
        if (Object.keys(filters).includes('createdAt')) {
          filters.createdAt = new Date(filters.createdAt).setDate(
            new Date(filters.createdAt).getDate(),
          );
          filters.createdAt = new Date(filters.createdAt).toISOString().substring(0, 10);
        }
        if (Object.keys(filters).includes('updatedAt')) {
          filters.updatedAt = new Date(filters.updatedAt).setDate(
            new Date(filters.updatedAt).getDate(),
          );
          filters.updatedAt = new Date(filters.updatedAt).toISOString().substring(0, 10);
        }
      }

      try {
        await this.$store.dispatch('DataGrids/fetchGoalTypes', {
          page: this.page - 1,
          size: this.perPage,
          sort: [this.sortField, this.sortOrder],
          filters: filters && Object.keys(filters).length > 0
            ? `&${new URLSearchParams(filters).toString()}` : '',
        });
        this.total = this.goalTypes.totalElements;
      } catch (error) {
        console.error(error);
      }
    },

    /**
     * onPageChange
     *
     * handle page change events
     * @param {Number} page
     */
    onPageChange(page) {
      this.page = page;
      this.from += this.perPage;
      this.fetchGoalTypes();
    },

    /**
     * onSort
     *
     * @param {String} field
     * @param {String} order
     */
    onSort(field, order) {
      this.sortField = field;
      this.sortOrder = order;
      this.fetchGoalTypes();
    },

    /**
     * onFilter
     *
     * @param {object} filters
     */
    onFilter(filters) {
      this.filters = { ...this.filters, ...filters };
      this.fetchGoalTypes();
    },

    /**
     * resetFilters
     *
     */
    resetFilters() {
      this.$refs.goalTypesTable.resetMultiSorting();
      this.$refs.goalTypesTable.filters = {};
      this.filters = {};
      this.fetchGoalTypes();
    },

    /**
     * onEdit
     *
     * @param {object} goalType
     */
    onEdit(goalType) {
      this.$store.dispatch('Settings/fetchGoalType', goalType.id);
      this.selectedGoalTypeId = goalType.id;
      this.$emit('is-editing', true);
      this.isEditing = true;
    },

    /**
     * searchCustomField
     *
     */
    searchCustomField(value) {
      this.searchClause = value;
      this.searchClause = value;
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.fetchGoalTypes();
      }, 800);
    },

    /**
     * updateGoalType
     *
     */
    async updateGoalType() {
      const payload = { ...this.goalType };
      try {
        await this.$store.dispatch('Settings/updateGoalType', {
          id: this.selectedGoalTypeId,
          data: payload,
        });
        await this.fetchGoalTypes();
        this.isEditing = false;
        this.$emit('is-editing', false);
        this.selectedGoalTypeId = null;
        this.$store.commit('Settings/CLEAR_GOAL_TYPE');
      } catch (error) {
        console.error(error);
      }
    },

    /**
     * cancelUpdate
     *
     */
    async cancelUpdate() {
      try {
        await this.fetchGoalTypes();
        this.isEditing = false;
        this.$emit('is-editing', false);
        this.selectedGoalTypeId = null;
        this.$store.commit('Settings/CLEAR_GOAL_TYPE');
        this.$emit('reset-fields');
      } catch (error) {
        console.error(error);
      }
    },

    async deleteGoalType(payload) {
      try {
        await this.$store.dispatch('Settings/deleteGoalType', payload);
        await this.fetchGoalTypes();
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style lang="css" scoped>
</style>
